import { render, staticRenderFns } from "./MunicipioBrasil.vue?vue&type=template&id=0ac72c4a&lang=pug"
import script from "./MunicipioBrasil.vue?vue&type=script&lang=js"
export * from "./MunicipioBrasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports